import { useEffect, type ReactNode } from "react";
import { IoMdClose } from "react-icons/io";

interface OverlayProps {
  show: boolean;
  onClose?: () => void;
  children: ReactNode;
  className?: string;
  hideCloseButton?: boolean;
  fullHeight?: boolean;
}

export function Overlay({
  show,
  onClose,
  children,
  className = "",
  hideCloseButton = false,
  fullHeight = false,
}: OverlayProps) {
  const hideChatbot = show && fullHeight;
  useEffect(() => {
    if (!hideChatbot) return;
    window.dispatchEvent(
      new CustomEvent("hamd:chatbot-visibility", { detail: { hidden: true } }),
    );
    return () => {
      window.dispatchEvent(
        new CustomEvent("hamd:chatbot-visibility", { detail: { hidden: false } }),
      );
    };
  }, [hideChatbot]);

  if (!show) return null;

  const containerClasses = [
    "flex flex-col w-full",
    fullHeight ? "h-screen max-h-screen" : "max-h-[90vh]",
    "max-w-lg",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const contentClasses = [
    fullHeight ? "p-0" : "px-6 py-6",
    "flex-1 overflow-y-auto",
    fullHeight ? "h-full" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className="fixed inset-0 bg-modal/80 flex items-center justify-center z-50">
      <div className="bg-black/10 fixed top-0 left-0 w-full h-full -z-10" />
      <div className={containerClasses}>
        {!hideCloseButton && (
          <div className="flex justify-end p-4 pb-2">
            <div className="w-8 h-8 flex items-center justify-center">
              <button
                onClick={onClose}
                className="w-8 h-8 rounded-full flex items-center justify-center transition-colors duration-200 bg-primary hover:bg-primary/80 cursor-pointer"
                aria-label="Close overlay"
              >
                <IoMdClose size={20} className="text-white" />
              </button>
            </div>
          </div>
        )}
        <div className={contentClasses}>{children}</div>
      </div>
    </div>
  );
}
